const heroBg = "/lovable-uploads/2bb14950-418a-4143-94a2-dfd749783abf.png";
import JoinNowButton from "@/components/landing/JoinNowButton";
import SiteNav from "@/components/landing/SiteNav";

const Hero = () => {
  // Remove redundant preload since it's now in HTML head for better LCP
  return (
    <>
      <SiteNav />
      <header className="relative overflow-hidden">
        <section className="relative hero-container py-10 md:py-16 overflow-hidden">
        <div className="absolute inset-0 -z-10">
          <img
            src={heroBg}
            alt="Colorful fashion collage background with diverse models wearing modern outfits showcasing the latest fashion trends"
            className="h-full w-full object-cover"
            loading="eager"
            fetchPriority="high"
            width={1335}
            height={890}
            sizes="100vw"
            decoding="sync"
          />
          <div className="absolute inset-0 bg-background/10" />
        </div>

        <div className="container px-4 md:px-8 lg:px-12">
          <div className="mx-auto max-w-[85vw] md:max-w-[80vw] lg:max-w-[75vw] xl:max-w-[70vw] rounded-3xl border bg-background/60 backdrop-blur-xl p-6 sm:p-8 md:p-12 shadow-elegant animate-enter flex flex-col">
            <div>
              <h1 className="font-roxborough text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold leading-tight sm:leading-relaxed tracking-tight">
                The future of Fashion Commerce is in your feed
              </h1>
              <p className="mt-8 text-lg md:text-xl text-muted-foreground">
                <a 
                  href="https://outfitalliance.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                  aria-label="Visit OutfitAlliance main website"
                >
                  OutfitAlliance
                </a> helps you earn more from your posts by matching your outfits to products from top fashion brands — boosting your revenue while we handle the rest.
              </p>
            </div>
            <div className="mt-4 flex justify-between items-center">
              <div className="font-roxborough text-foreground font-medium text-xl">
                Cloutfit<span className="text-foreground">.</span>ai
              </div>
              <JoinNowButton />
            </div>
          </div>
        </div>
        </section>
      </header>
    </>
  );
};

export default Hero;
